import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2g8zsudmn8: FaireBrandEntity = {
  token: "b_2g8zsudmn8",
  type: "brand",
  name: "Votivo",
  avatarUrl:
    "https://cdn.faire.com/fastly/cf63a8ff5c57dd59f1e17df0d9a1d0568255950a2922d1fd6efa51e22b83b68b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/e58792519fb859cf003745ce9ca6ae6f72ad0c8617211290866f378a7c2a387c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/cf63a8ff5c57dd59f1e17df0d9a1d0568255950a2922d1fd6efa51e22b83b68b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e58792519fb859cf003745ce9ca6ae6f72ad0c8617211290866f378a7c2a387c.jpeg",
  location: "Spartanburg, SC, USA",
  minimumOrderDollars: 500,
  rating: 4.8,
  reviewCount: 30,
  isTopShop: true,
  isInsider: true,
  description:
    "Since 1994, Votivo has been crafting meticulously formulated fragrances that transform everyday moments into memorable experiences. From its beginnings in Seattle to its current home in South Carolina, Votivo continues its tradition of creating one-of-a-kind fragrances through sophisticated formulations that reflect depth, richness, and complexity. \n\nFor more information, visit: www.VOTIVO.com\n\n\n\n\nVotivo Seller Policies:\nAll retailers must be approved by a OneCoast Territory Manager for your area. Once approved, retailers agree to comply with our Minimum Advertised Pricing Policy (MAP), which requires advertising at a minimum of 100% markup (keystone) from current wholesale pricing. Votivo products may only be sold at an approved brick-and-mortar location and/or on ecommerce websites you own and operate directly. Sale of Votivo products on third-party marketplace platforms — including but not limited to Amazon, Etsy, eBay, and Walmart.com — is strictly prohibited and constitutes a violation of these policies, subjecting the account to suspension. By placing an order, you agree to comply with these terms as a condition of continued approval to sell Votivo products.",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:08.746Z",
    importedBy: "entity-db-cli",
  },
};
